import { updateCloudinaryUrlParamsWithoutCalculation } from "../PagesUser/SelfServiceCampaignCreation/Previews/media-assets-lab/layout/Layout";

export const processAutocroppedImage = async (url, orientation, dimensions, templateId = "") => {
  if (!url || !dimensions) return url;

  // Get dimension template key based on templateId
  let dimensionTemplateKey;

  if (templateId) {
    if (dimensions[templateId]?.[orientation]) {
      dimensionTemplateKey = dimensions[templateId][orientation];
    } else if (dimensions[templateId]) {
      dimensionTemplateKey = dimensions[templateId];
    } else {
      dimensionTemplateKey = dimensions.default;
    }
  } else {
    dimensionTemplateKey = dimensions[orientation] || dimensions.default;
  }

  try {
    const { width, cloudAr, height, widthImage, heightImage } = dimensionTemplateKey || {};

    if (!width || !height) {
      console.error("Missing dimensions for template:", templateId, orientation);
    }

    // Default dimensions if missing
    const finalWidth = widthImage || width || 1200;
    const finalHeight = heightImage || height || 628;
    const finalAr = cloudAr || `${finalWidth}:${finalHeight}`;

    const finalURL = updateCloudinaryUrlParamsWithoutCalculation({
      url,
      w: finalWidth,
      h: finalHeight,
      ar: finalAr,
      replaceUrl: url.includes("shutterstock") ? "fetch" : "upload"
    });

    return finalURL;
  } catch (error) {
    console.error("Error processing image:", error);
    return url;
  }
};
